<div class="container py-4">
  <h2>{{ 'ADMIN.SETTINGS.TITLE' | translate }}</h2>
  <form class="mt-3" [formGroup]="form" (ngSubmit)="save()">
    <div class="mb-3"
         [mdbTooltip]="'ADMIN.SETTINGS.TRASHMODE_DEFAULT_TOOLTIP' | translate"
         placement="top"
         trigger="hover">
      <label class="form-label" for="trashmodeDefault">
        {{ 'ADMIN.SETTINGS.TRASHMODE_DEFAULT' | translate }}
      </label>
      <select id="trashmodeDefault" class="form-select" formControlName="trashmodeDefault">
        <option [ngValue]="null">{{ 'ADMIN.SETTINGS.TRASHMODE_NONE' | translate }}</option>
        <option value="single">{{ 'ADMIN.SETTINGS.TRASHMODE_SINGLE' | translate }}</option>
        <option value="global">{{ 'ADMIN.SETTINGS.TRASHMODE_GLOBAL' | translate }}</option>
        <option value="disposal">{{ 'ADMIN.SETTINGS.TRASHMODE_DISPOSAL' | translate }}</option>
      </select>
    </div>

    <app-mdb-button
      [text]="'SAVE'"
      color="primary"
      [isSubmit]="true"
      [loading]="loading"
    />
  </form>
</div>
